module.exports = __webpack_public_path__ + "static/media/hatchbackDark.0712aa6e.svg";